import { AfterContentInit, Component, HostListener, Input, NgZone } from '@angular/core';
import { ExerciceRow, ExercicesProvider } from '../../../exercices/providers/exercices-provider';
import { ExercicesExerciceViewDialogComponent } from '../../../exercices/components/exercice-view-dialog/exercice-view-dialog';
import { MatDialog } from '@angular/material/dialog';
import {
  ExerciceCategoryThumbnailComponent
} from "../../../exercices/components/exercice-category-thumbnail/exercice-category-thumbnail";
import { DurationVerbosePipe } from "../../../common/pipes/duration-verbose";
import { CommonModule } from '@angular/common';
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";
import { ConfigProvider } from '../../../config-provider.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'exercice-preview',
  providers: [],
  styleUrls: ['./exercice-preview.scss'],
  standalone: true,
  imports: [
    ExerciceCategoryThumbnailComponent,
    DurationVerbosePipe,
    CommonModule,
    MatTooltip,
    MatIcon,
    TranslateModule
  ],
  templateUrl: './exercice-preview.html'
})
export class ExercicePreviewComponent implements AfterContentInit {
    @Input() public exerciceRow: ExerciceRow = {} as ExerciceRow;
    public totalTime = 0;

    constructor(
        protected conf: ConfigProvider,
        private _exercicesProvider: ExercicesProvider,
        private _dialog: MatDialog,
        private _ngZone: NgZone
    ) {
    }

    @HostListener('click', ['$event'])
    public onClick(e: any): void {
        this._ngZone.run(() => {
            this._dialog.open(ExercicesExerciceViewDialogComponent, {
                data: {
                    exerciceRow: this.exerciceRow,
                }
            });
        });
    }

    public ngAfterContentInit(): void {
        this.totalTime = this._exercicesProvider.getTotalTime(this.exerciceRow);
    }
}
